import { Permission } from '@ptvn-react/authentication';
import { DisplayValueIconMap } from '../../models/Model';
import BBL from '../../../assets/images/bank/BBL.png';
import SCB from '../../../assets/images/bank/SCB.png';
import KBANK from '../../../assets/images/bank/KBANK.png';
import KTB from '../../../assets/images/bank/KTB.png';
import TTB from '../../../assets/images/bank/TTB.png';
import GSB from '../../../assets/images/bank/GSB.png';
import BAY from '../../../assets/images/bank/BAY.png';
import BAAC from '../../../assets/images/bank/BAAC.png';
import UOB from '../../../assets/images/bank/UOB.png';
import GHB from '../../../assets/images/bank/GHB.png';
import CIMBT from '../../../assets/images/bank/CIMBT.png';
import CITY from '../../../assets/images/bank/CITY.png';
import DBK from '../../../assets/images/bank/DBK.png';
import HSBC from '../../../assets/images/bank/HSBC.png';
import ICBC from '../../../assets/images/bank/ICBC.png';
import ISBT from '../../../assets/images/bank/ISBT.png';
import KPP from '../../../assets/images/bank/KPP.png';
import LH from '../../../assets/images/bank/LH.png';
import MCB from '../../../assets/images/bank/MCB.png';
import SCBT from '../../../assets/images/bank/SCBT.png';
import SMBC from '../../../assets/images/bank/SMBC.png';
import TCRB from '../../../assets/images/bank/TCRB.png';
import TISCO from '../../../assets/images/bank/TISCO.png';
import SME from '../../../assets/images/bank/SME.png';
import EXIM from '../../../assets/images/bank/EXIM.png';
import MegaICBC from '../../../assets/images/bank/Mega ICBC.png';

export class DateTimeFormat {
  public static readonly DDMMYYYY_SLASH = 'DD/MM/YYYY';
  public static readonly DDMMYYYY_HYPHEN = 'DD-MM-YYYY';
  public static readonly DDMMYYYY = 'DDMMYYYY';
  public static readonly YYYYMMDD_HYPHEN = 'YYYY-MM-DD';
  public static readonly HHmm = 'HH:mm';
  public static readonly hhmmA = 'hh:mm A';
  public static readonly hhmmssA = 'hh:mm:ss A';
  public static readonly DDMMYYY_SLASH_hhmmA = 'DD/MM/YYYY, hh:mm A';
}
export class TimeZone {
  public static readonly ASIA_BANGKOK = 'Asia/Bangkok';
}

export class BankOfThai {
  public static readonly BKKBTHBK = new DisplayValueIconMap(
    'Common.Bank.BKKBTHBK',
    'BKKBTHBK',
    BBL,
  );
  public static readonly SICOTHBK = new DisplayValueIconMap(
    'Common.Bank.SICOTHBK',
    'SICOTHBK',
    SCB,
  );
  public static readonly KASITHBK = new DisplayValueIconMap(
    'Common.Bank.KASITHBK',
    'KASITHBK',
    KBANK,
  );
  public static readonly KRTHTHBK = new DisplayValueIconMap(
    'Common.Bank.KRTHTHBK',
    'KRTHTHBK',
    KTB,
  );
  public static readonly TMBKTHBK = new DisplayValueIconMap(
    'Common.Bank.TMBKTHBK',
    'TMBKTHBK',
    TTB,
  );
  public static readonly GSBATHBK = new DisplayValueIconMap(
    'Common.Bank.GSBATHBK',
    'GSBATHBK',
    GSB,
  );
  public static readonly AYUDTHBK = new DisplayValueIconMap(
    'Common.Bank.AYUDTHBK',
    'AYUDTHBK',
    BAY,
  );
  public static readonly BAABTHBK = new DisplayValueIconMap(
    'Common.Bank.BAABTHBK',
    'BAABTHBK',
    BAAC,
  );
  public static readonly UOVBTHBK = new DisplayValueIconMap(
    'Common.Bank.UOVBTHBK',
    'UOVBTHBK',
    UOB,
  );
  public static readonly GOHUTHB1 = new DisplayValueIconMap(
    'Common.Bank.GOHUTHB1',
    'GOHUTHB1',
    GHB,
  );
  public static readonly UBOBTHBK = new DisplayValueIconMap(
    'Common.Bank.UBOBTHBK',
    'UBOBTHBK',
    CIMBT,
  );
  public static readonly CITITHBX = new DisplayValueIconMap(
    'Common.Bank.CITITHBX',
    'CITITHBX',
    CITY,
  );
  public static readonly DEUTTHBK = new DisplayValueIconMap(
    'Common.Bank.DEUTTHBK',
    'DEUTTHBK',
    DBK,
  );
  public static readonly HSBCTHBK = new DisplayValueIconMap(
    'Common.Bank.HSBCTHBK',
    'HSBCTHBK',
    HSBC,
  );
  public static readonly ICBKTHBK = new DisplayValueIconMap(
    'Common.Bank.ICBKTHBK',
    'ICBKTHBK',
    ICBC,
  );
  public static readonly TIBTTHBK = new DisplayValueIconMap(
    'Common.Bank.TIBTTHBK',
    'TIBTTHBK',
    ISBT,
  );
  public static readonly KKPBTHBK = new DisplayValueIconMap(
    'Common.Bank.KKPBTHBK',
    'KKPBTHBK',
    KPP,
  );
  public static readonly LAHRTHB2 = new DisplayValueIconMap('Common.Bank.LAHRTHB2', 'LAHRTHB2', LH);
  public static readonly MHCBTHBK = new DisplayValueIconMap(
    'Common.Bank.MHCBTHBK',
    'MHCBTHBK',
    MCB,
  );
  public static readonly SCBLTHBX = new DisplayValueIconMap(
    'Common.Bank.SCBLTHBX',
    'SCBLTHBX',
    SCBT,
  );
  public static readonly STBCTHBK = new DisplayValueIconMap(
    'Common.Bank.STBCTHBK',
    'STBCTHBK',
    SMBC,
  );
  public static readonly THCETHB1 = new DisplayValueIconMap(
    'Common.Bank.THCETHB1',
    'THCETHB1',
    TCRB,
  );
  public static readonly TFPCTHB1 = new DisplayValueIconMap(
    'Common.Bank.TFPCTHB1',
    'TFPCTHB1',
    TISCO,
  );
  public static readonly SMEBTHBK = new DisplayValueIconMap(
    'Common.Bank.SMEBTHBK',
    'SMEBTHBK',
    SME,
  );
  public static readonly EXTHTHBK = new DisplayValueIconMap(
    'Common.Bank.EXTHTHBK',
    'EXTHTHBK',
    EXIM,
  );
  public static readonly ICBCTHBK = new DisplayValueIconMap(
    'Common.Bank.ICBCTHBK',
    'ICBCTHBK',
    MegaICBC,
  );

  // public static readonly BKCHTHBK = new DisplayValueIconMap("ธนาคารแห่งประเทศจีน (ไทย) จำกัด (มหาชน)", "BKCHTHBK", "");
  // public static readonly ANZBTHBK = new DisplayValueIconMap("ธนาคารเอเอ็นแซด (ไทย) จำกัด (มหาชน)", "ANZBTHBK", "");
  // public static readonly CHASTHBX = new DisplayValueIconMap("ธนาคารเจพีมอร์แกน เชส", "CHASTHBX", "");
  // public static readonly SMBCTHBK = new DisplayValueIconMap("ธนาคารซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น", "SMBCTHBK", "");
  // public static readonly BNPATHBK = new DisplayValueIconMap("ธนาคารบีเอ็นพี พารีบาส์", "BNPATHBK", "");
  // public static readonly BOFATH2X = new DisplayValueIconMap("ธนาคารแห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น", "BOFATH2X", "");
  // public static readonly DCBBTHBK = new DisplayValueIconMap("ธนาคารอาร์ เอช บี จำกัด", "DCBBTHBK", "");
  // public static readonly BHOBTHBK = new DisplayValueIconMap("ธนาคารอินเดียนโอเวอร์ซีส์", "BHOBTHBK", "");
  // public static readonly OCBCTHBK = new DisplayValueIconMap("ธนาคารโอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด", "OCBCTHBK", "");

  public static readonly getAll = () => [
    BankOfThai.BKKBTHBK,
    BankOfThai.SICOTHBK,
    BankOfThai.KASITHBK,
    BankOfThai.KRTHTHBK,
    BankOfThai.TMBKTHBK,
    BankOfThai.GSBATHBK,
    BankOfThai.AYUDTHBK,
    BankOfThai.BAABTHBK,
    BankOfThai.UOVBTHBK,
    BankOfThai.GOHUTHB1,
    BankOfThai.UBOBTHBK,
    BankOfThai.CITITHBX,
    BankOfThai.DEUTTHBK,
    BankOfThai.HSBCTHBK,
    BankOfThai.ICBKTHBK,
    BankOfThai.TIBTTHBK,
    BankOfThai.KKPBTHBK,
    BankOfThai.LAHRTHB2,
    BankOfThai.MHCBTHBK,
    BankOfThai.SCBLTHBX,
    BankOfThai.STBCTHBK,
    BankOfThai.THCETHB1,
    BankOfThai.TFPCTHB1,
    BankOfThai.SMEBTHBK,
    BankOfThai.EXTHTHBK,
    BankOfThai.ICBCTHBK,
  ];
}

export class REGEX {
  public static readonly WEB_SITE =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}(\/\S*)?$/;
  public static readonly EMAIL =
    /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
  public static readonly DATE = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/;
  public static readonly PHONE = /^[0-9]{1,20}$/;
  public static readonly CALLING_CODE = /^(\+?\d{1,3}|\d{1,4})$/;
  public static readonly POSTAL_CODE = /^[0-9]{5}$/;
}

export enum SortDirectionEnum {
  ASC = 'asc',
  DESC = 'desc',
}

export const PageSizeDefaultValues = [20, 50, 100, 150, 200];
export type PageSizeDefaultType = typeof PageSizeDefaultValues[number];

export interface LanguageItem {
  key: string;
  title: string;
}

export class Language {
  public static readonly en: LanguageItem = { key: 'en', title: 'English' };
  public static readonly th: LanguageItem = { key: 'th', title: 'ภาษาไทย' };

  public static getLangByKey(key: string) {
    switch (key) {
      case Language.en.key:
        return Language.en;
      case Language.th.key:
        return Language.th;
      default:
        return undefined;
    }
  }
}

export class CookieName {
  public static readonly TENANT_ENTITY = 'tiduaa';
  public static readonly USER_SEARCH_HISTORY = 'ush';
  public static readonly SUPPLIER_ALERT_FREE_ALMOST_EXPIRE_TIME = 'safaet';
  public static readonly SUPPLIER_ALERT_ALMOST_EXPIRE_TIME_FIRST_PERIOD = 'saaetfp';
  public static readonly SUPPLIER_ALERT_ALMOST_EXPIRE_TIME_SECOND_PERIOD = 'saaetsp';
  public static readonly SUPPLIER_ALERT_ALMOST_EXPIRE_TIME_THIRD_PERIOD = 'saaettp';
  public static readonly ONE_TIME_SUPPLIER_ALERT_AFTER_SUBSCRIPTION = 'otsaas';
  public static readonly AUTH_CODE = 'auth_code';
  public static readonly ATTEMPTED_PATH_BEFORE_LOGIN_SUCCESS = 'apbls';
  public static readonly BUYER_TRACKING = 'tracking';
  public static readonly UAA_AUTH_ID = 'auth_sid';
  public static readonly SUPPLIER_ALERT_FIRST_UPGRADE_PACKAGE = 'safup';
  public static readonly BUYER_FIRST_TIME_POPUP = 'bftpop';
}

export class LocalStorageName {
  public static readonly UPDATE_QUOTATION_INFO = 'uqi';
  public static readonly CURRENT_IDP = 'cIDP';
}

export class UserPermissionConstant {
  public static readonly ERFX_CREATE_RFQ_USER: Permission[] = [
    {
      resource: 'erfx_resource',
      scopes: ['erfx_create_rfq_scope'],
    },
  ];
  public static readonly ERFX_SERVICE_ENABLED: Permission[] = [
    {
      resource: 'erfx_resource',
      scopes: ['erfx_service_enabled_scope'],
    },
  ];
}

export const SearchPageType = {
  DEFAULT: '',
  SUPPLIER_PODUCT_PROMOTION: 'supplier_product_promotion',
  SUPPLIER_PODUCT_NEW_IN: 'supplier_product_new_in',
  SUPPLIER_PODUCT_ALL: 'supplier_product_all',
};

export const GATrackConstant = {
  BuyerSearchJobBoard: 'Buyer Search Job Board',
  BuyerViewJobBoard: 'Buyer View Job Board',
  BuyerPostJobBoard: 'Buyer Post Job Board',
  BuyerEditJobBoard: 'Buyer Edit Job Board',
  CreateJobBoard: 'Create Job Board',
  CancelPostJobBoard: 'Cancel Job Board',
  SupplierSearchJobBoard: 'Supplier Search Job Board',
  SupplierViewJobBoard: 'Supplier View Job Board',
  DownloadFile: 'Download File',
  ConverErfx: 'Convert to ERFx',
  Unprocessable: 'Unprocessable',
  FailToUpload: 'Fail to upload file',
  UploadFile: 'Upload file',
  CancelQuote: 'Cancel Quote Job Board',
  CancelUpdateJobBoard: 'Cancel Update Job Board',
  QuoteJob: 'Quote Job Board',
  PreviousPage: 'Select previous page',
  NextPage: 'Select next page',
  SelectShowing: 'Select Showing',
  PtvnINFO: 'Click PTVN More Info',
  ChangeLang: 'Change Language',
  Footer: 'Change Lang Footer',
  ViewERFX: 'View ERFx',
  BuyerSection: 'Buyer Section',
  SupplierSection: 'Supplier Section',
  ClickJobItem: 'Click job item',
  ViewJobEmail: 'View Job Board via email',
  ReviewSupplierQuote: 'Review Supplier Quotation',
};

export const GA4TrackConstant = {
  Category: {
    Navigation: 'Navgiation',
    OutboundNavigation: 'OutboundNavigation',
    Modal: 'Modal',
    Search: 'Search',
    ProductDetail: 'ProductDetail',
    SupplierDetail: 'SupplierDetail',
    LeftNavigation: 'LeftNavigation',
    Category: 'Category',
  },
  Action: {
    Click: 'Click',
    GridBtnClick: 'GridBtnClick',
    ProfileBtnClick: 'ProfileBtnClick',
    HotSearch: 'HotSearch',
    ProductSearch: 'ProductSearch',
    CategorySearch: 'CategorySearch',
    Expand: 'Expand',
    Search: 'Search',
    SearchCat: 'SearchCat',
    Sort: 'Sort',
    CategoryFilterApply: 'CategoryFilterApply',
    PriceFilterApply: 'PriceFilterApply',
    LocationFilterApply: 'LocationFilterApply',
    MOQFilterApply: 'MOQFilterApply',
    BusinessTypeFilterApply: 'BusinessTypeFilterApply',
    ViewMore: 'ViewMore',
    ViewLess: 'ViewLess',
    ViewChartPrice: 'ViewChartPrice',
    SelectTimeRange: 'SelectTimeRange',
    ClickSupplierBranch: 'ClickSupplierBranch',
    SelectSupplierBranch: 'SelectSupplierBranch',
    RelatedSupplierClick: 'RelatedSupplierClick',
    PopularProduct: 'PopularProduct',
  },
};

export const MobileWidthSize = 576;
export const TabletWidthSize = 768;

export enum AlertType {
  RFQ = 'RFQ',
  RFI = 'RFI',
  RFP = 'RFP',
  BLD = 'BLD',
}

export class Contact {
  public static readonly PHONE_NUMBER = '02 034 4488';
  public static readonly EMAIL_SUPPLIER_CONNECT = 'supplierconnect@pantavanij.com';
}

export enum AppNameEnum {
  ERFX = 'eRFX',
  PROCUREMENT_BOARD = 'procurement-board',
  E_MARKET_PLACE = 'e-marketplace',
}

export const NewInProductWithInDays = 180;

export enum SupplierEventEnum {
  VIEW = 'view',
  RESPOND_BUYING_LEAD = 'respond_buying_lead',
  SUBMIT_RESPOND_BUYING_LEAD = 'submit_respond_buying_lead',
  SAVE_FAVORITE_BUYING_LEAD = 'save_favorite_buying_lead',
  REMOVE_FAVORITE_BUYING_LEAD = 'remove_favorite_buying_lead',
}

export enum BuyerEventEnum {
  VIEW = 'view',
  REQUEST_QUOTATION = 'request_quotation',
}

export enum BuyerEventItemTypeEnum {
  PRODUCT = 'product',
  SUPPLIER = 'supplier',
}
